unit Gadget.Enumerations;

interface

{$SCOPEDENUMS ON}
{$IFDEF USE_AURELIUS_MAPPING}

uses
  System.SysUtils,
  Aurelius.Mapping.Attributes;
{$ENDIF}

type

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'New,SessionContinued,RetrievedByUser,RetrievedBySession,ApiSession')]
  {$ENDIF}
  TSessionKind = (New, SessionContinued, RetrievedByUser, RetrievedBySession, ApiSession);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'New,Saved,Completed,Deleted,Confirmed')]
  {$ENDIF}
  /// <summary>
  ///   Basket status
  /// </summary>
  TBasketStatus = (
    /// <summary>
    ///   Basket created.
    /// </summary>
    New,
    /// <summary>
    ///   Only for website. this basket has been saved by the customer and is available to be reloaed and continued.
    /// </summary>
    Saved,
    /// <summary>
    ///   The basket has been completed and payment received/set up (invoice/card paid/dd details received.
    /// </summary>
    Completed,
    /// <summary>
    ///   The basket has been deleted.
    /// </summary>
    Deleted,
    /// <summary>
    ///   This is for the Api and is a state that is set prior to receiving/setting up payment. If the affiliate is 'Invoiced' then this status won't be
    ///   used and Completed imeediately set on the call to /Confirm
    /// </summary>
    Confirmed);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,MobilePhone,Laptop,Tablet,VRHeadset,Watch,GamesConsole')]
  {$ENDIF}
  TGadgetType = (None, MobilePhone, Laptop, Tablet, VRHeadset, Watch, GamesConsole);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Available,NotAvailable')]
  {$ENDIF}
  TLossCoverStatus = (Available, NotAvailable);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Unknown,Deleted,NotActive,New,Saved,Active,Cancelled,Completed')]
  {$ENDIF}
  TPolicyStatus = (Unknown, Deleted, NotActive, New, Saved, Active, Cancelled, Completed);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'MonthlyCover,AnnualCover')]
  {$ENDIF}
  TPremiumKind = (MonthlyCover, AnnualCover);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,ThirdParty,Customer, APIUser')]
  {$ENDIF}
  TAffiliateKind = (None, ThirdParty, Customer, APIUser);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Inactive,Suspended,Active,Approved')]
  {$ENDIF}
  TAffiliateStatus = (Inactive, Suspended, Active, Approved);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,Discount')]
  {$ENDIF}
  TBrandOfferKind = (None, Discount);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,Active,Expired,NotExist')]
  {$ENDIF}
  TOfferStatus = (None, Active, Expired, NotExist);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Active,Suspended,Deleted')]
  {$ENDIF}
  TBasicStatus = (Active, Suspended, Deleted);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'System,Pending,Inactive,Active,Suspended,Deleted,NotExists,Deceased')]
  {$ENDIF}
  TUserStatus = (System, Pending, Inactive, Active, Suspended, Deleted, NotExists, Deceased);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Customer,Admin')]
  {$ENDIF}
  TUserCategory = (Customer, Admin);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'App,Email,SMS')]
  {$ENDIF}
  TMFAPreference = (App, Email, SMS);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,Contact,Primary,Secondary')]
  {$ENDIF}
  TCustomerType = (None, Contact, Primary, Secondary);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'PerHour,PerDay,PerWeek,PerMonth,PerYear')]
  {$ENDIF}
  TTimePeriod = (PerHour, PerDay, PerWeek, PerMonth, PerYear);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,PayPal,Revolut,Stripe,DirectDebit,BACS,Cheque,ApiInvoice')]
  {$ENDIF}
  TPaymentProvider = (None, PayPal, Revolut, Stripe, DirectDebit, BACS, Cheque, ApiInvoice);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,Invoice,Direct')]
  {$ENDIF}
  TApiBillingKind = (None,
    /// <summary>
    /// The premiums are billed to the affiliate by invoice
    /// </summary>
    Invoice,
    /// <summary>
    /// The premiums are paid by the customer
    /// </summary>
    Direct);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'New,Success,Failed,Cancelled')]
  {$ENDIF}
  TPaymentState = (New, Success, Failed, Cancelled);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Payment,Refund')]
  {$ENDIF}
  TPaymentType = (Payment, Refund);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Other,Deposit,Balance')]
  {$ENDIF}
  TPaymentLevel = (Other, Deposit, Balance);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Premium,Other')]
  {$ENDIF}
  TCostItemType = (Premium, Other);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'None,Value,Memory')]
  {$ENDIF}
  TDiscriminatorKind = (None, Value, Memory);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'PremiumTable,SchemeTable')]
  {$ENDIF}
  TPremiumSource = (PremiumTable, SchemeTable);

  {New Enumerations for Premium Extensions}

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'Gadget,Manufacturer,Product')]
  {$ENDIF}
  /// <summary>
  ///   Describes the aggregation level of the premiums for a gadget type
  /// </summary>
  TAggregationLevel = (
    /// <summary>
    ///   Gadget level e.g. Mobile Phone
    /// </summary>
    Gadget,
    /// <summary>
    ///   Gadget and Manufacturer e.g. Mobile Phone / Apple
    /// </summary>
    Manufacturer,
    /// <summary>
    ///   Gadget, Manufacturer and Product e.g. Mobile Phone / Apple/ iPhone 15 Pro
    /// </summary>
    Product);

  {$IFDEF USE_AURELIUS_MAPPING}
  [Enumeration(TEnumMappingType.emString, 'SingleMetric,BothMetrics')]
  {$ENDIF}
  /// <summary>
  ///   What are the mandatory requirements for a premium
  /// </summary>
  TRequiredValidation = (
    /// <summary>
    ///   Only requires the TDiscriminatorKind to be provided (e.g. Value <b>OR</b> Memory)
    /// </summary>
    SingleMetric,
      /// <summary>
      ///   Requires both metrics to be provided (Value <b>AND</b> Memory)
      /// </summary>
      BothMetrics);

const
  Annual_Premium_Multiplier = 10;
  Device_Age_Validity = 36;

  Yes_No: array[boolean] of string = ('No', 'Yes');
  Basket_Status: array[TBasketStatus] of string = ('New', 'Saved', 'Completed', 'Deleted', 'Confirmed');

  Policy_Status: array[TPolicyStatus] of string = ('Unknown', 'Deleted', 'NotActive', 'New', 'Saved', 'Active',
    'Cancelled', 'Completed');
  Gadget_Types: array[TGadgetType] of string = ('None', 'Mobile phone', 'Laptop', 'Tablet', 'VR headset', 'Watch',
    'Games console');

  Gadget_Type: array[TGadgetType] of string = ('None', 'MobilePhone', 'Laptop', 'Tablet', 'VRHeadset', 'Watch',
    'GamesConsole');

  Gadget_Types_Loss_Excluded = [TGadgetType.None, TGadgetType.Laptop];
  Premium_Kind: array[TPremiumKind] of string = ('Monthly', 'Annually');
  Premium_Kind_Descriptor: array[TPremiumKind] of string = ('a month', 'a year');

  Cost_Item_Type: array[TCostItemType] of string = ('Premium', 'Other');
  Payment_Provider: array[TPaymentProvider] of string = ('None', 'PayPal', 'Revolut', 'Stripe', 'DirectDebit', 'BACS',
    'Cheque', 'ApiInvoice');
  Payment_State: array[TPaymentState] of string = ('New', 'Success', 'Failed', 'Cancelled');
  Payment_Type: array[TPaymentType] of string = ('Payment', 'Refund');
  Payment_Level: array[TPaymentLevel] of string = ('Other', 'Deposit', 'Balance');
  Payment_Level_Description: array[TPaymentLevel] of string = ('Payment', 'Deposit Payment', 'Balance Payment');

  { TODO : Really needs it's own file }
  // LookUp Consts
  AGREE_TERMS_TEXT = 'AGREE-TERMS-TEXT';
  MISSING_SERIALS = 'MISSING-SERIALS';
  DEVICE_TOO_OLD = 'DEVICE-TOO-OLD';
  THANK_YOU_URL = 'THANK-YOU-URL';

implementation

{$SCOPEDENUMS OFF}

end.

